import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	buttonContainer: {
		marginLeft: 'auto',
		marginRight: '0',
	},
	chevron: {
		marginLeft: 5,
	},
	contactCount: {
		color: '#4a4a4a',
		marginLeft: '40%',
	},
	contactsTitle: {
		marginLeft: 'calc(40% - 5px)',
	},
	container: {
		border: '1px solid #CCC',
		color: '#4a4a4a',
	},
	empty: {
		margin: '20px auto',
		textAlign: 'center',
		width: 220,
	},
	header: {
		alignItems: 'center',
		borderBottom: '1px solid #CCC',
		display: 'flex',
		justifyContent: 'flex-start',
		padding: '8px 16px',
		width: 'calc(100% - 31px)',
	},
	linkBrowse: {
		cursor: 'pointer',
		marginTop: 8,
		textAlign: 'center',
	},
	listArea: {
		height: 290,
		overflowY: 'auto',
	},
	noPolicy: {
		color: '#4a4a4a',
		marginTop: 15,
		textAlign: 'center',
	},
	selectAllCheckbox: {},
	selectAllText: {
		color: '#4a4a4a',
		fontSize: 14,
		paddingLeft: 10,
		width: 60,
	},
	tag: {
		marginLeft: '20px !important',
	},
	tagCheckbox: {},
	tagRow: {
		':first-of-type': {
			paddingTop: 16,
		},
		':last-of-type': {
			paddingBottom: 16,
		},
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-start',
		padding: '13px 16px',
	},
	tagRowHighlight: {
		background: '#F3FBFF',
	},
});
